<h1><a href="/admin-home">Admin</a> - Dealers</h1>

<section>
  <p><label>Dealer:
    <input type="text" id="admin-dealer" [(ngModel)]="search" (keyup)="displayDealers()" autofocus="autofocus">
  </label>
  <label>
    Country:
    <select id="filterCountry" [(ngModel)]="country" (change)="displayDealers()">
      @for (c of countries; track c) {
        <option [value]="c">
          {{c}}
        </option>
      }
    </select>
  </label>
</p>
<!-- <p><button (click)="download()">Download Report Data</button></p> -->
</section>

<section>
  <p>{{loading}}</p>
  <table class="data">
    <thead><tr><td>PA Code</td><td>Name</td><td>Country</td><td>Techs</td><td>Enrolled</td><td></td></tr></thead>
    <tbody>
      @for (dealer of displayedDealers; track dealer) {
        <tr>
          <td>{{dealer.pa_code}}</td>
          <td>{{dealer.name}}</td>
          <td>{{dealer.country}}</td>
          <td class="number">{{dealer.tech_count}}</td>
          <th>{{dealer.subscribed}}</th>
          <td><button (click)="fly(dealer)">Be {{dealer.pa_code}}</button></td>
        </tr>
      }
    </tbody>
  </table>
</section>
